module.exports = __webpack_public_path__ + "img/401.556693c5.jpeg";